import { useParams, Navigate } from 'react-router-dom';
import BoxesJson from '../data/modularBoxes.json';
import logo from '../images/glometal-logo.PNG';
import {
  ModBoxDetails
} from '../utils/constants';

const getSrc = (code) => {
  try {
    return require(`../images/products/${code}.png`);
  } catch (error) {
    return logo;
  }
}

const ModularBoxInfo = () => {
  const { type } = useParams();
  const product = BoxesJson.find(item => item.name === type);
  if(!product) {
    return <Navigate to="/404" replace />;
  }

  return (
    <div className='modular-page'>

      <div className='cards-wrapper'>
        <div className='width-50 productinfo-card'>
          <h3 style={{ color: "#e47931" }}>Product Information</h3>
          <h1>{product.title}</h1>
          <p style={{ textAlign: 'justify' }}>{product.description}</p>
          {ModBoxDetails[type]}
        </div>
        <div className='width-40'>
          <img src={getSrc(product.name)} alt={product.title} width='100%'/>
        </div>

      </div>
    </div>
  );
};

export default ModularBoxInfo;